(function () {
  const ACTIVE_SIDEBAR = 'mega-menu__sidebar-item--active';
  const ACTIVE_PANE = 'mega-menu__detail-pane--active';

  function initMegaMenuPanels() {
    // Preload all mega menu images on idle
    function preloadMegaImages() {
    document.querySelectorAll('.mega-menu__detail-pane img').forEach((img) => {
        if (img.src) {
        const preload = new Image();
        preload.src = img.src;
        }
    });
    }

    if ('requestIdleCallback' in window) {
    requestIdleCallback(preloadMegaImages);
    } else {
    setTimeout(preloadMegaImages, 200);
    }
    document.querySelectorAll('.mega-menu__two-panel').forEach((panel) => {
      const buttons = panel.querySelectorAll('.mega-menu__sidebar-item');
      const panes = panel.querySelectorAll('.mega-menu__detail-pane');
      let hoverTimeout;

      function activate(targetId) {
        buttons.forEach((btn) => {
          btn.classList.toggle(ACTIVE_SIDEBAR, btn.dataset.megaTarget === targetId);
        });
        panes.forEach((pane) => {
          pane.classList.toggle(ACTIVE_PANE, pane.dataset.megaPane === targetId);
        });
      }

      buttons.forEach((btn) => {
        // Desktop: hover with small delay to prevent flicker
        btn.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            activate(btn.dataset.megaTarget);
          }, 80);
        });

        // Mobile / accessibility: click
        btn.addEventListener('click', () => {
          activate(btn.dataset.megaTarget);
        });

        // Keyboard: Enter/Space
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate(btn.dataset.megaTarget);
          }
        });
      });

      // Cancel hover timeout when leaving sidebar
      panel.querySelector('.mega-menu__sidebar')?.addEventListener('mouseleave', () => {
        clearTimeout(hoverTimeout);
      });
    });
  }

  // Init on DOMContentLoaded and after Shopify section renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuPanels);
  } else {
    initMegaMenuPanels();
  }

  // Re-init when sections are reloaded in the theme editor
  document.addEventListener('shopify:section:load', initMegaMenuPanels);
})();